import { render } from "./BasicProductionDetails.vue?vue&type=template&id=0bc5d8c6"
import script from "./BasicProductionDetails.vue?vue&type=script&lang=js"
export * from "./BasicProductionDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/alejo/Development/AT/Apps/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__